import { Gtm } from '~/types/@nuxtjs/gtm';

export const pushCleanTags = ($gtm: Gtm, tags: Object) => {
  $gtm.push({ ecommerce: null });
  $gtm.push(tags);
};
